import { useMutation } from '@tanstack/react-query'
import { integrationOptionValues } from '../../v3/integrationOptionValues'
import { type IntegrationOptionValue } from './types'

type UpdateParams = Pick<IntegrationOptionValue, 'id' | 'name'>

/**
 * Invalidate `globalQueryKeys.integrationOptionValues` in the call site's
 * `onSuccess`.
 */
export function useUpdateIntegrationOptionValue() {
  return useMutation({
    mutationFn: ({ id, name }: UpdateParams) =>
      integrationOptionValues.update({
        params: { path: { integration_option_value_id: id } },
        requestBody: {
          data: { id, type: 'integration_option_value', attributes: { name } },
        },
      }),
  })
}
